import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetDashboardAccess } from '../services/DashboardAccess/GetDashboardAccess';

export const useDashboardAccessStore = defineStore('dashboardAccess', () => {
  const dashboardAccess = ref<any>(null);

  const fetchDashboardAccess = async () => {
    try {
      const data = await GetDashboardAccess();
      dashboardAccess.value = data;
      return data;
    } catch (err) {
      console.error('Failed to fetch dashboard access:', err);
      throw err;
    }
  };

  return {
    dashboardAccess,
    fetchDashboardAccess,
  };
});
